import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-apply1-whatyouget',
    'templateUrl': './apply1WhatYouGet.page.html',
    'styleUrls': ['./apply1WhatYouGet.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, IonicModule ]
})
export class Apply1WhatYouGetPage extends ViewBasePage implements OnInit, OnDestroy {
    constructor(injector: Injector) {
        super(injector);
    }

    public override async ngOnInit() {
        super.ngOnInit();
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
    }

    public onBackButtonClick() {
        this.router.navigateByUrl('/welcome');
    }

    public onApplyForFreeTrialClick() {
        this.router.navigateByUrl('/apply/applicationForm');
    }
}
